module.exports = __webpack_public_path__ + "static/notfound2-71e360e25ab0a35be4664f9226a0dfed.jpg";